import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

type InputTranslation = {
    label: string;
    placeholder: string;
    error: InputErrorTranslation;
};

type InputErrorTranslation = {
    required: string;
};

export interface IServiceAddCtaDialogData {
    cta?: {
        [key: string]: string;
    };
    link?: string;
    langs: string[];
    translatedValues: {
        title: string;
        infos: string;
        name: {
            [key: string]: InputTranslation;
        };
        link: InputTranslation;
        cancelButton: {
            text: string;
        };
        submitButton: {
            text: string;
        };
    };
}

@Component({
    selector: 'service-add-cta-dialog',
    templateUrl: './service-add-cta-dialog.component.html',
    styleUrls: ['./service-add-cta-dialog.component.scss'],
})
export class ServiceAddCtaDialogComponent implements OnInit {
    form: FormGroup = this.formBuilder.group({
        cta: this.formBuilder.group({}),
        link: new FormControl('', [Validators.required]),
    });

    get cta(): AbstractControl {
        return this.form.get('cta');
    }

    get link(): AbstractControl {
        return this.form.get('link');
    }

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: IServiceAddCtaDialogData,
        private dialogRef: MatDialogRef<ServiceAddCtaDialogComponent>,
        private formBuilder: FormBuilder,
    ) {}

    ngOnInit(): void {
        this.data.langs.forEach((lang) => {
            (this.form.get('cta') as FormGroup).addControl(lang, new FormControl('', [Validators.required]));
        });

        this.cta.patchValue(this.data.cta);
        this.link.patchValue(this.data.link);
    }

    close(): void {
        this.dialogRef.close();
    }

    onCancel(): void {
        this.close();
        this.form.reset();
    }

    onSubmit(): void {
        this.form.markAllAsTouched();
        this.form.updateValueAndValidity();

        if (this.form.valid) {
            this.dialogRef.close(this.form.value);
        }
    }
}
